import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { sousServiceService } from '../../api';
import './SousService.css';

const SousService = () => {
  const [sousServices, setSousServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSousServices = async () => {
      try {
        const response = await sousServiceService.getAll();
        
        if (response.data) {
          setSousServices(response.data);
        } else {
          // Si l'API ne renvoie pas de format standard {data: [...]}
          setSousServices(response);
        }
        
      } catch (err) {
        console.error('Erreur détaillée:', {
          message: err.message,
          response: err.response?.data,
          status: err.response?.status
        });
        
        setError(err.response?.data?.message || 
                'Erreur lors du chargement des sous-services');
      } finally {
        setLoading(false);
      }
    };

    fetchSousServices();
  }, []);

  if (loading) {
    return <div className="loading">Chargement en cours...</div>;
  }

  if (error) {
    return (
      <div className="error-container">
        <h3>Erreur</h3>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Réessayer</button>
      </div>
    );
  }

  return (
    <div className="sous-service-container">
      <h2>Liste des Sous-Services</h2>
      
      <table className="sous-service-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nom</th>
            <th>Catégorie</th>
          </tr>
        </thead>
        <tbody>
          {sousServices.map((service) => (
            <tr key={service.id}>
              <td>{service.id}</td>
              <td>{service.nom}</td>
              <td>{service.categorie?.nom || 'N/A'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SousService;